import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestKind } from "../../types/requestTypes";
import { ErrorResponse } from "../../api/Requests";

interface RequestState {
  isLoading: boolean;
  kind: RequestKind | null;
  errorResponses: ErrorResponse[];
  successMessage: string | null;
}

const initialState: RequestState = {
  isLoading: false,
  kind: null,
  errorResponses: [],
  successMessage: null,
};

const requestStateSlice = createSlice({
  name: "requestState",
  initialState,
  reducers: {
    startRequest(state, action: PayloadAction<{ kind: RequestKind }>) {
      state.isLoading = true;
      state.kind = action.payload.kind;
      state.successMessage = null;
    },
    requestSuccess(state, action: PayloadAction<{ message?: string }>) {
      state.isLoading = false;
      state.successMessage = action.payload.message ?? null;
    },
    requestError(state, action: PayloadAction<ErrorResponse>) {
      state.isLoading = false;
      state.errorResponses.push(action.payload);
    },
    removeErrorByIndex: (state, action: PayloadAction<number>) => {
      state.errorResponses = state.errorResponses.filter((_, i) => i !== action.payload);
    },
    clearRequestState(state) {
      state.isLoading = false;
      state.kind = null;
      state.errorResponses = [];
      state.successMessage = null;
    },
    clearSuccessMessage(state) {
      state.successMessage = null;
    },
  },
});

export const { startRequest, requestSuccess, requestError, removeErrorByIndex, clearRequestState, clearSuccessMessage} =
  requestStateSlice.actions;

export default requestStateSlice.reducer;